import React from "react";
import { SocialIcon } from "react-social-icons";
import useReveal from "../../useReveal";

const socials = [
  { url: "https://www.linkedin.com/in/juhani-rajalahti-b822b911/", label: "LinkedIn" },
  { url: "https://github.com/rajalahti", label: "GitHub" },
  { url: "mailto:juhani.rajalahti@gmail.com", label: "Email" },
];

export default function Footer() {
  const ref = useReveal();

  return (
    <footer
      id="contact"
      ref={ref}
      style={{
        position: "relative",
        padding: "clamp(80px, 16vh, 180px) clamp(20px, 5vw, 48px) 36px",
        overflow: "hidden",
        borderTop: "1px solid var(--line)",
        background:
          "linear-gradient(180deg, transparent, rgba(52,224,255,0.05) 60%, rgba(255,77,157,0.05))",
      }}
    >
      {/* Giant background word */}
      <span
        aria-hidden
        style={{
          position: "absolute",
          bottom: "-2%",
          left: "50%",
          transform: "translateX(-50%)",
          fontFamily: "var(--display)",
          fontWeight: 700,
          fontSize: "clamp(5rem, 20vw, 20rem)",
          color: "rgba(52,224,255,0.05)",
          lineHeight: 0.8,
          whiteSpace: "nowrap",
          pointerEvents: "none",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
        }}
      >
        Transmit
      </span>

      <div style={{ maxWidth: "var(--maxw)", margin: "0 auto", position: "relative", zIndex: 1 }}>
        <p
          className="reveal"
          style={{
            fontFamily: "var(--mono)",
            fontSize: "0.78rem",
            textTransform: "uppercase",
            letterSpacing: "0.18em",
            color: "var(--cyan)",
            marginBottom: "26px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <span
            style={{
              width: "9px",
              height: "9px",
              borderRadius: "50%",
              background: "var(--cyan)",
              boxShadow: "0 0 10px var(--glow)",
              animation: "pulseGlow 1.6s ease-in-out infinite",
            }}
          />
          04 — OPEN CHANNEL
        </p>

        <h2
          className="reveal glow-text"
          data-stagger="80"
          style={{
            fontFamily: "var(--display)",
            fontWeight: 700,
            fontSize: "clamp(2.2rem, 8vw, 5.6rem)",
            lineHeight: 0.98,
            letterSpacing: "0.01em",
            maxWidth: "18ch",
            textTransform: "uppercase",
          }}
        >
          Have a project, <span style={{ color: "var(--cyan)" }}>or just</span> want to say hei?
        </h2>

        <a
          href="mailto:juhani.rajalahti@gmail.com"
          className="reveal"
          data-stagger="80"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "12px",
            marginTop: "clamp(28px, 5vh, 48px)",
            fontFamily: "var(--mono)",
            fontSize: "clamp(1rem, 3vw, 1.7rem)",
            color: "var(--text)",
            textDecoration: "none",
            border: "1px solid var(--line-strong)",
            padding: "14px 22px",
            background: "rgba(52,224,255,0.05)",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(52,224,255,0.15)";
            e.currentTarget.style.boxShadow = "0 0 24px rgba(52,224,255,0.3)";
            e.currentTarget.style.color = "var(--cyan)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(52,224,255,0.05)";
            e.currentTarget.style.boxShadow = "none";
            e.currentTarget.style.color = "var(--text)";
          }}
        >
          <span style={{ color: "var(--cyan)" }}>»</span>
          juhani.rajalahti@gmail.com
        </a>

        <div
          className="reveal"
          data-stagger="80"
          style={{ display: "flex", gap: "14px", marginTop: "42px", alignItems: "center" }}
        >
          {socials.map((s) => (
            <SocialIcon
              key={s.label}
              url={s.url}
              target={s.url.startsWith("mailto") ? undefined : "_blank"}
              rel="noreferrer noopener"
              bgColor="transparent"
              fgColor="#34e0ff"
              style={{
                width: 46,
                height: 46,
                border: "1px solid var(--line-strong)",
              }}
            />
          ))}
        </div>

        {/* Bottom telemetry rule */}
        <div
          style={{
            marginTop: "clamp(60px, 12vh, 130px)",
            paddingTop: "22px",
            borderTop: "1px solid var(--line)",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "12px",
            fontFamily: "var(--mono)",
            fontSize: "0.7rem",
            letterSpacing: "0.08em",
            color: "var(--text-faint)",
            textTransform: "uppercase",
          }}
        >
          <span>© {new Date().getFullYear()} J. RAJALAHTI</span>
          <span style={{ color: "var(--cyan)" }}>ESPOO · 60.2°N 24.6°E</span>
          <span>BUILT WITH REACT</span>
        </div>
      </div>
    </footer>
  );
}
